// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"789b35fe","732":"a5ae2dfc","977":"52e1162c"}[chunkId] + ".chunk.js";
};